module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921104149_T.d9e4ac54.jpg";